"use client";
import React, { use } from "react";
import { FormContainer } from "./formContainer";
import { GiftCardSkeleton } from "@/components/loadingSkeleton/loadingSkeleton";
import { ClientWrapperProps } from "@/dto/clientWrapper";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const GiftCardMainContainer = ({
  merchant,
  paymentConfigPromise,
}: ClientWrapperProps) => {
  if (!merchant) {
    return <GiftCardSkeleton />;
  }

  const merchantPaymentConfig =
    paymentConfigPromise && use(paymentConfigPromise);

  return (
    <div data-testid={applyDataTestId(pom.giftCard.giftCardMainContainer)}>
      <FormContainer
        merchant={merchant}
        merchantPaymentConfig={merchantPaymentConfig}
      />
    </div>
  );
};
